import { createAsyncThunk } from '@reduxjs/toolkit';

import { IProgress, IUserPerformanceData } from '.';
import { ApiPaths } from '../../../api/APIPaths';
import APIDataProvider, { TApiResponse } from '../../../api/ApiDataProvider';

export type TGetUserPerformanceData = {
  curriculum: string;
  subject?: string;
};

const apiDataProvider = new APIDataProvider();

export const getProgressByCurriculum = createAsyncThunk(
  '/progress/get-curriculum',
  async (curriculum: string) => {
    const path = `${ApiPaths.progress}/${curriculum}`;

    const response = await apiDataProvider.get<TApiResponse<IProgress>>(path);

    return response.data;
  }
);

export const getUserPerformanceData = createAsyncThunk(
  '/progress/user/performance',
  async (data: TGetUserPerformanceData) => {
    const path = `${ApiPaths.progress}/user/performance`;

    const response = await apiDataProvider.post<
      TApiResponse<IUserPerformanceData[]>
    >(path, data);

    return response.data;
  }
);

export default getProgressByCurriculum;
